import { ReactElement, useCallback } from 'react';

import { HealthcarePracticeFormBean } from '../common/healthcarePractice';
import { ServiceProvidingLocationFormBean } from '../common/serviceProvidingLocation';
import { ServiceProvidingLocationUpdateLink } from '../serviceProvidingLocationUpdate/ServiceProvidingLocationUpdateLink';

type ServiceProvidingLocationFromRpwdlUpdateLinkProps = {
   readonly healthcarePractice: HealthcarePracticeFormBean;
   readonly serviceProvidingLocation: ServiceProvidingLocationFormBean;
   readonly onUpdate: (formData: ServiceProvidingLocationFormBean) => void;
};

export const ServiceProvidingLocationFromRpwdlUpdateLink = (
   props: ServiceProvidingLocationFromRpwdlUpdateLinkProps
): ReactElement => {
   const { healthcarePractice, serviceProvidingLocation, onUpdate } = props;
   const prepareInitialData = useCallback(
      // eslint-disable-next-line @typescript-eslint/require-await
      async (): Promise<ServiceProvidingLocationFormBean> => serviceProvidingLocation,
      [serviceProvidingLocation]
   );

   return (
      <ServiceProvidingLocationUpdateLink
         healthcarePractice={healthcarePractice}
         prepareInitialData={prepareInitialData}
         onUpdate={onUpdate}
      />
   );
};
